export default __webpack_public_path__ + "static/media/Parker.ae9c0be4.png";